import type * as React from "react";
import { cn } from "@/lib/utils";

interface DashboardLayoutProps {
	children: React.ReactNode;
	className?: string;
}

function DashboardLayout({ children, className }: DashboardLayoutProps) {
	return (
		<main
			data-dashboard-scroll-container
			className={cn("pb-20 lg:pb-0", className)}
		>
			{children}
		</main>
	);
}

// Content wrapper with proper padding
interface DashboardContentProps {
	children: React.ReactNode;
	className?: string;
}

function DashboardContent({ children, className }: DashboardContentProps) {
	return (
		<div
			className={cn(
				"max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-8",
				className,
			)}
		>
			{children}
		</div>
	);
}

export { DashboardLayout, DashboardContent };
